import UserData from "../classes/api/result/accountmodule/UserData";
import { AuthToken } from "./AuthToken";
import UserApi from "./UserApi";

const UserSession = {
    EnsureUserDataAsync: async (): Promise<UserData> => {
        let authSession = await AuthToken.get();
        return (await UserApi.EnsureStandardAccountAsync(authSession.Token));
    }
}

export default UserSession;
